import React from "react";
import parser from "html-react-parser";
import { Link } from "react-router-dom";
import VideoBlock3 from "../VideoBlock/VideoBlock3";

const Hero15 = ({ data }) => {
  const { subTitle, title, text, imgSrc, videoSrc } = data;
  return (
    <div className="">
      <div className="container">
        <h2 className="blue center pb-10 pt-11">{text}</h2>
        <div className="st-hero-in">
          {/* <VideoBlock3 imgSrc={imgSrc} videoSrc={videoSrc} /> */}
          <img className="root-image" src={imgSrc} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Hero15;
